import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SftpReaderForm = ({
  form,
  onSubmit,
  onChange,
}: {
  form: any;
  onSubmit: any;
  onChange: any;
}) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext() as { node: any };
  const { id } = node;

  // Watch the addSftpCredentials checkbox state
  const showCredentials = form.watch('addSftpCredentials');

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="sftpReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="sftpReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="sftpReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="sftpReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="sftpReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      {/* Checkbox to control credential fields visibility */}
      <FormField
        controlId="sftpReaderFormAddCredentials"
        label="Add SFTP Credentials"
        name="addSftpCredentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      {/* Conditionally render credential fields */}
      {showCredentials && (
        <>
          <FormField
            controlId="sftpReaderFormCredentialType"
            label="credentialType"
            name="properties.credentialType"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Credential Type"
            error={errors?.properties?.credentialType?.message}
          />
          <FormField
            controlId="sftpReaderFormHost"
            label="host"
            name="properties.host"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Host"
            error={errors?.properties?.host?.message}
          />
          <FormField
            controlId="sftpReaderFormUser"
            label="user"
            name="properties.user"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter User"
            error={errors?.properties?.user?.message}
          />
          <FormField
            controlId="sftpReaderFormPassword"
            label="password"
            name="properties.password"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            type="password"
            placeholder="Enter Password"
            error={errors?.properties?.password?.message}
          />
          <FormField
            controlId="sftpReaderFormPrivateKey"
            label="privateKey"
            name="properties.privateKey"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
            placeholder="Enter Private Key"
            // rows={10}
            error={errors?.properties?.privateKey?.message}
          />
          <FormField
            controlId="sftpReaderFormPassphrase"
            label="passphrase"
            name="properties.passphrase"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Passphrase"
            error={errors?.properties?.passphrase?.message}
          />
          <FormField
            controlId="sftpReaderFormPort"
            label="port"
            name="properties.port"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Port"
            error={errors?.properties?.port?.message}
          />
        </>
      )}

      <FormField
        controlId="sftpReaderFormDebug"
        label="debug"
        name="properties.debug"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.debug?.message}
      />
      <FormField
        controlId="sftpReaderFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Path"
        required
        error={errors?.properties?.path?.message}
      />
      <FormField
        controlId="sftpReaderFormFilePattern"
        label="filePattern"
        name="properties.filePattern"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter File Pattern"
        error={errors?.properties?.filePattern?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SftpReaderForm;
